var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "header" } },
    [
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { cols: "12", id: "main_content_maxwidthset" },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "ma-0 pa-0",
              attrs: {
                align: "center",
                justify: "space-between",
                id: "header_body",
              },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: { cols: "2", id: "header_text" },
                },
                [_vm._v(" " + _vm._s(_vm.tc("headerTitle")) + " ")]
              ),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { align: "center", justify: "end" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 mr-4",
                          staticStyle: { width: "10rem" },
                          attrs: { cols: "auto" },
                        },
                        [
                          _c("v-select", {
                            staticClass: "ma-0 pa-1 status_select",
                            attrs: {
                              items: _vm.cameraStatusList,
                              dense: "",
                              "hide-details": "",
                              outlined: "",
                              dark: "",
                              "item-text": "label",
                              "item-value": "value",
                            },
                            model: {
                              value: _vm.selectedCameraStatus,
                              callback: function ($$v) {
                                _vm.selectedCameraStatus = $$v
                              },
                              expression: "selectedCameraStatus",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 mr-5",
                          attrs: { cols: "auto" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "pl-10 pr-10",
                              attrs: {
                                id: "blue_btn",
                                loading: _vm.areaLoading,
                              },
                              on: { click: _vm.clickGroupEdit },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.tc("storeConditions")) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }